import React from 'react';
import { BrandDisplay, LoginContainer } from './components';

/**
 * 登录页面主组件
 * 已进行组件拆分和性能优化
 */
function Login() {

  return (
    <div 
      style={{ backgroundImage: 'url(/asset/images/login_bg.png)' }} 
      className="w-full h-screen bg-cover bg-no-repeat flex lg:flex-row flex-col justify-between 2xl:px-60 xl:px-24 lg:px-10 px-6 items-center"
    >
      {/* 品牌展示区域 */}
      <BrandDisplay />
      
      {/* 登录表单区域 */}
      <LoginContainer />
    </div>
  );
}

export default Login;
